import { SxProps, Theme } from '@mui/material';

type TStyles = {
  card: SxProps<Theme>;
  cardTopTextContainer: SxProps<Theme>;
  cardBottomTextContainer: SxProps<Theme>;
  cardTopContainer: SxProps<Theme>;
  verificationModal: SxProps<Theme>;
  infoText: SxProps<Theme>;
};

export const styles: TStyles = {
  card: (theme: Theme) => ({
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
    borderRadius: theme.spacing(1),
  }),
  cardTopTextContainer: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: theme.spacing(1),
  }),
  cardBottomTextContainer: (theme: Theme) => ({
    padding: theme.spacing(3, 4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
  cardTopContainer: (theme: Theme) => ({
    cursor: 'pointer',
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 4),
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey.additionalGrey}`,
  }),
  verificationModal: (theme: Theme) => ({
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.common.white,
    gap: theme.spacing(3),
  }),

  infoText: (theme: Theme) => ({
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  }),
};
